import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { toast } from 'react-toastify';
import { Button } from 'primereact/button';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetBrands, AddBrand, UpdateBrand, DeleteBrand } from 'services/other/brand.service';
import { TableRowEdit } from 'components/Table/TableRowEdit';
import { NameColumn} from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { BrandValidationSchema } from 'utilities/ValidationSchema/Other/BrandValidationSchema';
import duplicateNameChecker from 'utilities/duplicateNameChecker';

const Brand = () => {
    const { brandList, brandListLoading } = useSelector((state) => state.brandList);
    const { brandAdd, brandAddLoading } = useSelector((state) => state.brandAdd);
    const { brandUpdate, brandUpdateLoading } = useSelector((state) => state.brandUpdate);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
    };

    const updateInitialValue = {
        ...updateData,
    };
    

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: BrandValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });

    const editBrand = (product) => {
        setShowForm(true); // * set the form to true
        setUpdateData(product);
    };

    // delete 1
    const toastPrime = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteBrand(id))
                await toastPrime.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetBrands());
            },
            reject: () => {
                toastPrime.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateBrand(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddBrand(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetBrands());
    }, [brandAdd, brandUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Name", sortableBody: NameColumn },
    ];


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "name",
            name: "name",
            type: "text",
            labelFor: "Name",
            label: "Enter a Name",
            required: true,
            className: "col-12 md:col-12",
            onBlur: (e) => duplicateNameChecker(e.target.value, brandList, updateData, setDuplicateNameExist),
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editBrand(rowData)} />
                <Toast ref={toastPrime} />
                <ConfirmPopup />
                <Button 
                    onClick={(e) => {
                        DeleteModal(e, rowData.id);
                    }} 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-warning mt-2"
                />
            </div>
        );
    }

    const onRowEditComplete = (e) => {
        let { newData } = e;

        dispatch(UpdateBrand(newData))
    };

    return (
        <>
            <TableRowEdit
                //data
                tableHeaderName="Brand Details"
                tableColumns={tableColumns}
                data={brandList}
                loading={brandListLoading}
                dataKey="id"

                editMode="row"
                onRowEditComplete={onRowEditComplete}

                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <CreateModal 
                dialogVisible={showForm} 
                column={12} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Brand`} 
                modalWidth="400px" 
                reset={resetForm} 
                btnLoading={brandAddLoading || brandUpdateLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={4}
                col2={updateData ? 3 : 4}
                col3={4}
            />
        </>
    );
};

export default Brand;
